import type { ReactNode } from 'react'
import { useCallback, useMemo } from 'react'
import { useIntl } from 'react-intl'
import TextLink from 'LuxKit/TextLink'
import usePendingLoginHandler from 'hooks/usePendingLoginHandler'
import noop from 'lib/function/noop'
import { LOYALTY_LANDING_PAGE, LOYALTY_PURCHASE_POINTS_PAGE } from 'loyalty/constants/loyaltyRoutes'

const bold = (chunks: ReactNode) => <strong>{chunks}</strong>
const topUp = (chunks: ReactNode) => <TextLink to={`/${LOYALTY_PURCHASE_POINTS_PAGE}`} weight="regular">{chunks}</TextLink>
const activities = (chunks: ReactNode) => <TextLink to={`/${LOYALTY_LANDING_PAGE}`} weight="regular">{chunks}</TextLink>

interface Props {
  isLoggedIn: boolean
}

export default function PromoMembershipMessage({ isLoggedIn }: Props) {
  const intl = useIntl()
  const onSignup = usePendingLoginHandler(noop)
  const signup = useCallback((chunks: ReactNode) => <TextLink onClick={onSignup} weight="regular">{chunks}</TextLink>, [onSignup])
  return useMemo(() => isLoggedIn
    ? intl.formatMessage({
        id: 'NDt63YW1NU_nOi2VCRp6',
        defaultMessage: '<bold>Need Société Points?</bold> <topUp>Top up your balance</topUp> and use them straight away, or earn more through eligible <activities>Société activities.</activities>',
        description: 'Footer for logged-in customers with no points on the Maldives one-point sale banner, linking to top-ups and earning activities.',
      }, { bold, topUp, activities })
    : intl.formatMessage({
        id: '2STlDKbGAaLh9YQEXqkz',
        defaultMessage: '<bold>Not a Société member?</bold> <signup>Sign up for free</signup>',
        description: 'Signup invitation for logged-out customers on the Maldives one-point promotion banner and information modal.',
      }, { bold, signup }), [intl, isLoggedIn, signup])
}
